import { Fancybox } from '@fancyapps/ui';

function fancyboxPDP() {
  Fancybox.bind('#product-gallery-fancybox', {
    Carousel: {
      Navigation: {
        prevTpl:
          '<svg width="40" height="11" viewBox="0 0 40 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.87523 11L0.000233137 5.95833L6.79884 -2.86301e-06L3.3369 5.28L39.5479 5.28L39.5479 6.17571L3.3369 6.17571L6.87523 11Z" fill="#ffffff"/></svg>',
        nextTpl:
          '<svg width="40" height="11" viewBox="0 0 40 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M32.6726 0L39.5476 5.04167L32.749 11L36.211 5.72H0V4.82429H36.211L32.6726 0Z" fill="#231F20"/></svg>',
      },
    },
  });
}

export { fancyboxPDP as default };
